// Utility function to format currency with thousand separators
export function formatCurrency(
  amount: number,
  includeCurrency: boolean = true,
): string {
  const formatted = amount.toLocaleString('en-SG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return includeCurrency ? `$${formatted}` : formatted
}
